import * as React from 'react';

const SvgAttachOutline = (props) => (React.createElement("svg", Object.assign({ width: 24, height: 24, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
    React.createElement("path", { d: "M12 22c3.86 0 7-3.14 7-7V7c0-2.758-2.242-5-5-5S9 4.242 9 7v8c0 1.654 1.346 3 3 3s3-1.346 3-3V7.957h-2V15c0 .551-.449 1-1 1-.551 0-1-.449-1-1V7c0-1.654 1.346-3 3-3s3 1.346 3 3v8c0 2.758-2.242 5-5 5s-5-2.242-5-5V7.957H5V15c0 3.86 3.14 7 7 7Z", fill: "currentColor" })));

export { SvgAttachOutline as default };
